import moment from 'moment';

class Article {
  constructor({
    _id = null,
    title = '',
    image,
    description = '',
    publishDate = null,
    active = false,
    createdAt = null,
    updatedAt = null,
  }) {
    const { id: imageId = null, url: imageUrl = '' } = image ? image : {};
    this.id = _id;
    this.title = title;
    this.image = {
      id: imageId,
      url: imageUrl,
    };
    this.description = description;
    this.publishDate = publishDate ? moment(publishDate) : null;
    this.active = active;
    this.createdAt = createdAt ? moment(createdAt) : null;
    this.updatedAt = updatedAt ? moment(updatedAt) : null;
  }
}

export default Article;
